type ThumbnailContainer = {
    containerDimensions: ThumbnailContainerDimensions;
    thumbnailAspectRatio: ThumbnailAspectRatio;
};

export type ThumbnailAspectRatio = {
    height: number;
    width: number;
};

export type ThumbnailContainerDimensions = {
    height: number;
    width: number;
};

export type ThumbnailFillParams = {
    containerSpacing: number;
    maxContainerHeight: number;
    minContainerHeight: number;
    minContainerWidth: number;
    rowWidth: number;
};

function chunkThumbnails(aspectRatios: ThumbnailAspectRatio[], params: ThumbnailFillParams): ThumbnailContainer[][] {
    const chunks: ThumbnailContainer[][] = [];
    const thumbs: ThumbnailContainer[] = aspectRatios.map(aspectRatio => ({
        containerDimensions: { height: 0, width: 0 },
        thumbnailAspectRatio: aspectRatio,
    }));
    let chunkWidth = 0;
    let lastIndex = 0;
    thumbs.forEach((thumb, index) => {
        thumb.containerDimensions.height = params.minContainerHeight;
        thumb.containerDimensions.width = scaledWidth(
            thumb.thumbnailAspectRatio,
            params.minContainerHeight,
            params.minContainerWidth,
        );
        chunkWidth += thumb.containerDimensions.width + params.containerSpacing;
        if (chunkWidth > params.rowWidth) {
            chunks.push(thumbs.slice(lastIndex, index));
            lastIndex = index;
            chunkWidth = thumb.containerDimensions.width + params.containerSpacing;
        }
    });
    chunks.push(thumbs.slice(lastIndex));
    return chunks;
}

function scaleThumbnailContainerDimensionss(
    chunks: ThumbnailContainer[][],
    params: ThumbnailFillParams,
): ThumbnailContainerDimensions[] {
    const thumbnailDimensions: ThumbnailContainerDimensions[] = [];
    chunks.forEach(chunk => {
        const totalWidth = chunk.reduce(
            (accumulator, currentValue) =>
                accumulator +
                scaledWidth(currentValue.thumbnailAspectRatio, params.minContainerHeight, params.minContainerWidth),
            0,
        );
        const targetTotalWidth = params.rowWidth - (chunk.length - 1) * params.containerSpacing;
        const multiplier = targetTotalWidth / totalWidth;
        chunk.forEach(thumb => {
            const containerFilledWidth =
                scaledWidth(thumb.thumbnailAspectRatio, params.minContainerHeight, params.minContainerWidth) *
                multiplier;
            const containerFilledHeight =
                (containerFilledWidth * params.minContainerHeight) / thumb.containerDimensions.width;
            thumb.containerDimensions.width = containerFilledWidth;
            thumb.containerDimensions.height = containerFilledHeight;
        });

        // Reduce height for all containers within a row that exceed maximum height
        let chunkHeight = Math.max(...chunk.map(chunkAsset => chunkAsset.containerDimensions.height));
        if (chunkHeight > params.maxContainerHeight) {
            chunkHeight = params.maxContainerHeight;
        }
        chunk.forEach(thumb => {
            thumb.containerDimensions.height = chunkHeight;
            thumbnailDimensions.push(thumb.containerDimensions);
        });
    });
    return thumbnailDimensions;
}

function scaledWidth(dimensions: ThumbnailAspectRatio, minContainerHeight: number, minContainerWidth: number): number {
    const newWidth = (dimensions.width / dimensions.height) * minContainerHeight;
    return newWidth > minContainerWidth ? newWidth : minContainerWidth;
}

export function fitThumbnailsToWidth(
    thumbnailsOriginal: ThumbnailAspectRatio[],
    params: ThumbnailFillParams,
): ThumbnailContainerDimensions[] {
    const chunked = chunkThumbnails(thumbnailsOriginal, params);
    return scaleThumbnailContainerDimensionss(chunked, params);
}
